/* Paloah Co. section interactions — vanilla JS, no dependencies.
   Cart adds go through Shopify.actions.updateCart (standard actions bundle Horizon
   already loads) so Horizon's cart drawer + bubble update; falls back to a normal
   form POST to /cart/add when the bundle is unavailable. */
(function () {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const designMode = document.documentElement.classList.contains('shopify-design-mode');

  /* ---------- Toast ---------- */
  let toast = $('#pl-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'pl-toast'; toast.className = 'pl-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
  }
  let toastTimer;
  function say(msg) {
    toast.textContent = msg; toast.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => toast.classList.remove('show'), 2600);
  }

  function initSection(root) {
    /* Tilted elements: read data-rot into CSS var */
    $$('.pl-tilt', root).forEach(el => el.style.setProperty('--r', (el.dataset.rot || 0) + 'deg'));

    /* Scroll reveals */
    const revealEls = $$('.pl-reveal', root);
    const letters = $$('.pl-letters', root);
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      revealEls.forEach(el => el.classList.add('is-in'));
      letters.forEach(l => l.classList.add('is-in'));
    } else {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      revealEls.forEach(el => io.observe(el));
      letters.forEach(l => io.observe(l));
      $$('.pl-moodgrid, .pl-products, .pl-squishrow, .pl-badges', root).forEach(grid => {
        $$('.pl-reveal', grid).forEach((el, i) => el.style.transitionDelay = (i * 70) + 'ms');
      });
    }

    /* Add-to-cart forms (single-variant products) */
    $$('form.pl-addform', root).forEach(form => {
      if (form.dataset.plBound) return; form.dataset.plBound = '1';
      form.addEventListener('submit', async (e) => {
        const actions = window.Shopify && window.Shopify.actions;
        if (!actions || !actions.updateCart) return; // let the browser POST to /cart/add
        e.preventDefault();
        const btn = $('button[type="submit"]', form);
        const id = form.querySelector('input[name="id"]').value;
        const qty = Number((form.querySelector('input[name="quantity"]') || {}).value || 1);
        const label = btn.textContent;
        btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true');
        try {
          const result = await actions.updateCart({ lines: [{ merchandiseId: id, quantity: qty }] }, { event: { context: 'product' } });
          if (result && result.userErrors && result.userErrors.length) throw new Error(result.userErrors[0].message);
          btn.textContent = form.dataset.addedText || 'Added ✓'; btn.classList.add('is-added');
          say((form.dataset.title || 'Item') + ' ' + (form.dataset.addedMsg || 'added to your cart'));
          document.dispatchEvent(new CustomEvent('cart:add', { detail: { id, qty } }));
          if (actions.openCart) actions.openCart().catch(() => {});
          setTimeout(() => { btn.textContent = label; btn.classList.remove('is-added'); }, 1600);
        } catch (err) {
          console.warn('[paloah] add to cart failed', err);
          say(err && err.message ? err.message : 'Could not add to cart');
        } finally {
          btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy');
        }
      });
    });

    /* FAQ accordion: animate open/close height */
    $$('.pl-accordion details', root).forEach(d => {
      if (d.dataset.plBound) return; d.dataset.plBound = '1';
      const summary = $('summary', d), body = $('.pl-accordion__body', d);
      if (!summary || !body || reduce) return;
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (d.classList.contains('is-animating')) return;
        d.classList.add('is-animating');
        if (d.open) {
          const h = body.offsetHeight;
          body.style.height = h + 'px';
          requestAnimationFrame(() => { body.style.transition = 'height .4s cubic-bezier(.22,1,.36,1)'; body.style.height = '0px'; });
          body.addEventListener('transitionend', () => { d.open = false; body.style.cssText = ''; d.classList.remove('is-animating'); }, { once: true });
        } else {
          d.open = true;
          const h = body.offsetHeight;
          body.style.height = '0px';
          requestAnimationFrame(() => { body.style.transition = 'height .45s cubic-bezier(.22,1,.36,1)'; body.style.height = h + 'px'; });
          body.addEventListener('transitionend', () => { body.style.cssText = ''; d.classList.remove('is-animating'); }, { once: true });
        }
      });
    });

    /* Magnetic CTAs (desktop pointer only) */
    if (!reduce && window.matchMedia('(pointer:fine)').matches) {
      $$('[data-magnetic]', root).forEach(btn => {
        if (btn.dataset.plBound) return; btn.dataset.plBound = '1';
        btn.addEventListener('pointermove', (e) => {
          const r = btn.getBoundingClientRect();
          const x = (e.clientX - (r.left + r.width / 2)) / r.width;
          const y = (e.clientY - (r.top + r.height / 2)) / r.height;
          btn.style.transform = `translate(${x * 10}px, ${y * 8 - 2}px)`;
        });
        btn.addEventListener('pointerleave', () => { btn.style.transform = ''; });
      });
    }

    /* Newsletter form: friendly inline validation (real submit goes to Shopify) */
    $$('form.pl-form', root).forEach(form => {
      if (form.dataset.plBound) return; form.dataset.plBound = '1';
      form.addEventListener('submit', (e) => {
        const email = $('input[type="email"]', form); const msg = $('.pl-form__msg', form);
        if (email && (!email.validity.valid || !email.value)) { e.preventDefault(); if (msg) msg.textContent = form.dataset.invalidMsg || 'Please enter a valid email.'; email.focus(); }
      });
    });
  }

  function initAll() { initSection(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();

  /* Theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', (e) => initSection(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const d = e.target.closest ? e.target.closest('details') : null; if (d) d.open = true;
  });

  /* Ticker: pause when tab hidden to save battery */
  document.addEventListener('visibilitychange', () => {
    $$('.pl-ticker__track').forEach(t => t.style.animationPlayState = document.hidden ? 'paused' : 'running');
  });
})();
